module.exports = __webpack_public_path__ + "static/media/Douglas R.df1098e7.jpg";